<template>
  <v-container fluid fill-height>
    <v-card class="white mx-auto" width="30vw" min-height="400px">
      <div class="white mb-3">
        <v-img max-width="20vw" class="mx-auto" src="../assets/DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg"/>
      </div>
      
      <div class="text-center">
        <h2 class="mb-2">Select Tenant</h2>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation class="text-center">
        <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4"></v-progress-linear>
        
        <v-select
          v-model="selectedTenant"
          :items="tenants"
          :item-text="getTenantDisplayName"
          :item-value="getTenantValue"
          placeholder="Select a tenant"
          class="mb-4 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          dense
          :disabled="loading"
          return-object
        ></v-select>

        <v-btn
          style="width: 70%"
          color="black white--text"
          class="rounded-lg mb-3"
          :disabled="!selectedTenant || loading"
          :loading="submitting"
          @click="handleLogin"
        >
          Login
        </v-btn>
        
        <v-btn
          style="width: 70%"
          color="red"
          text
          class="rounded-lg mb-3"
          @click="handleLogout"
        >
          Logout
        </v-btn>
        
        <v-alert v-if="error" type="error" dismissible @input="error = null" class="mx-auto" style="width: 70%">
          {{ error }}
        </v-alert>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TenantSelection',
  data() {
    return {
      loading: false,
      submitting: false,
      error: null,
      selectedTenant: null,
      valid: false
    };
  },
  computed: {
    ...mapGetters(['getTenants']),
    tenants() {
      return this.getTenants || [];
    }
  },
  created() {
    this.loadTenants();
  },
  methods: {
    ...mapActions(['fetchTenants', 'selectTenant']),
    async loadTenants() {
      this.loading = true;
      this.error = null;
      try {
        await this.fetchTenants();
      } catch (error) {
        this.error = 'Failed to load tenants. Please try again.';
        console.error('Error loading tenants:', error);
      } finally {
        this.loading = false;
      }
    },
    async handleLogin() {
      if (!this.selectedTenant) return;
      
      this.submitting = true;
      this.error = null;
      try {
        await this.selectTenant(this.selectedTenant);
        this.$router.push('/');
      } catch (error) {
        this.error = 'Failed to select tenant. Please try again.';
        console.error('Error selecting tenant:', error);
      } finally {
        this.submitting = false;
      }
    },
    getTenantDisplayName(tenant) {
      return tenant?.name || tenant?.tenantName || tenant?.id || 'Unknown Tenant';
    },
    getTenantValue(tenant) {
      return tenant;
    },
    async handleLogout() {
      await this.$store.dispatch('logout');
    }
  }
};
</script>

